'use strict';
//***********************************************************************************
//***********************************************************************************
//**** cn_svg_tool_roof_dormer_edition : a tool to edit roof dormers
//***********************************************************************************
//***********************************************************************************

import { cn_svg_tool_edition } from './cn_svg_tool_edition';
import { cn_roof_dormer } from '../model/cn_roof_dormer';
import { cn_roof_dormer_handler } from './cn_roof_dormer_handler';

export class cn_svg_tool_roof_dormer_edition extends cn_svg_tool_edition {
    constructor(map) {
        super(map);
    }

    //***********************************************************************************
    //**** Selection callback
    //***********************************************************************************
    on_selection_change() {
        const obj = this;
        this._handlers = [];

        //*** We expect the selection to contain only openings */
        var sel = this._controller.get_selection();
        if (sel.length == 0 || sel.some(elt => elt.constructor != cn_roof_dormer))
            return false;

        this._handlers.push(new cn_roof_dormer_handler(sel, this._map));
        return true;
    }
}

